module.exports = __webpack_public_path__ + "img/7.82dc7817.gif";